<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.52925 12.0286C9.7896 11.7683 10.2117 11.7683 10.4721 12.0286L14.0007 15.5572L17.5292 12.0286C17.7896 11.7683 18.2117 11.7683 18.4721 12.0286C18.7324 12.289 18.7324 12.7111 18.4721 12.9714L14.9435 16.5L18.4721 20.0286C18.7324 20.289 18.7324 20.7111 18.4721 20.9714C18.2117 21.2318 17.7896 21.2318 17.5292 20.9714L14.0007 17.4428L10.4721 20.9714C10.2117 21.2318 9.7896 21.2318 9.52925 20.9714C9.2689 20.7111 9.2689 20.289 9.52925 20.0286L13.0578 16.5L9.52925 12.9714C9.2689 12.7111 9.2689 12.289 9.52925 12.0286Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "CloseX2833",
    props: {
        iconFill: {
            type: String,
            default: "#6F7287",
        },
    },
};
</script>
